import Immutable, { is as isEqual } from 'immutable'
import { connect } from 'react-redux'
import { func } from 'prop-types'
import { map } from 'react-immutable-proptypes'
import React from 'react'

import { addProduct, setAction } from '../utils/googleAnalytics'
import { loadCart, loadProduct, setBuyboxProductQuantity } from '../store/actions'
import { track } from '../utils/tracking'
import Theme from '../components/Theme'
import createMultiLanguageLinkTags from './utils/createMultiLanguageLinkTags'

export class ProductRaw extends React.Component {
  static propTypes = {
    viewError: map,
    shop: map,
    product: map,
    cart: map,
    setBuyboxProductQuantity: func.isRequired,
  }

  static storeUpdate = (props, state) => {
    const isForwardNavigation = props.location.action === 'PUSH'
    const productId = props.params.productId
    // look for the GUID to the requested slug somewhere in the state in order to save a db roundtrip
    let guid

    const categoryProducts = state
      .get('categoryProductData', Immutable.Map())
      .valueSeq()
      .map((a) => a.products)
      .reduce((a, b) => a.concat(b), [])
    const searchProducts = state
      .get('searchData', Immutable.Map())
      .valueSeq()
      .map((a) => a.products)
      .reduce((a, b) => a.concat(b), [])
    const productWithSlug = [...categoryProducts, ...searchProducts]
      .filter(Boolean)
      .find((product) => product.slug === productId)

    if (productWithSlug) guid = productWithSlug.productId

    const updates = []

    if (!state.get('cart')) updates.push(loadCart())
    if (isForwardNavigation || !state.getIn(['products', productId])) {
      updates.push(
        loadProduct({
          guid: guid || productId,
          slug: guid && productId,
        }),
      )
    }

    return updates
  }

  componentDidMount() {
    const { product, setBuyboxProductQuantity, cart } = this.props

    if (product) {
      setBuyboxProductQuantity(1)
      this.trackProductDetails(product, cart)
    }
  }

  componentDidUpdate(lastProps) {
    const { product, setBuyboxProductQuantity, cart } = this.props

    if (product && !isEqual(lastProps.product, product)) {
      setBuyboxProductQuantity(1)
      this.trackProductDetails(product, cart)
    }
  }

  trackProductDetails(product, cart) {
    track('product', { product: product, cart: cart })
    addProduct(product, ['id', 'name', 'variant', 'brand', 'price', 'currency'])
    setAction('detail')
  }

  static contentCreationDisabled = () => true

  render() {
    const { viewError, shop, product } = this.props

    if (viewError) return <Theme withLayout error={viewError} currentView="product" />
    if (!product) return null

    const title = product.get('title') || product.get('name')

    const metaTags = [
      <meta key="og:type" property="og:type" content="product" />,
      <meta key="og:title" property="og:title" content={title} />,
      <meta key="og:url" property="og:url" content={shop.getIn(['locationBase', 'origin']) + product.get('href')} />,
    ]

    if (product.get('image')) {
      metaTags.push(
        <meta key="og:image" property="og:image" content={product.getIn(['image', 'url'])} />,
        <meta key="og:image:width" property="og:image:width" content={product.getIn(['image', 'width'])} />,
        <meta key="og:image:height" property="og:image:height" content={product.getIn(['image', 'height'])} />,
      )
    }

    if (product.get('metaDescription')) {
      metaTags.push(
        <meta key="description" name="description" content={product.get('metaDescription')} />,
        <meta key="og:description" property="og:description" content={product.get('metaDescription')} />,
      )
    }

    const linkTags = createMultiLanguageLinkTags(shop, `p/${product.get('productId')}`)

    if (product.get('isVariationProduct')) {
      linkTags.push(
        <link
          key="canonical"
          rel="canonical"
          href={`${shop.getIn(['locationBase', 'origin'])}/p/${product.getIn(['variationMaster', 'slug'])}`}
        />,
      )
    }

    return (
      <Theme
        withLayout
        currentView="product"
        title={title}
        titleShouldIncludeShop={!product.get('title')}
        metaTags={metaTags}
        linkTags={linkTags}
      >
        {(renderView, props) =>
          renderView('Product', {
            ...props,
            product: product.toJS(),
          })
        }
      </Theme>
    )
  }
}

export default connect(
  (state, props) => ({
    viewError: state.getIn(['view', 'error']),
    shop: state.get('shop'),
    product: state.get('products').get(props.params.productId),
    cart: state.get('cart'),
  }),
  { setBuyboxProductQuantity },
)(ProductRaw)
